/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function GatewayModelTableConfig($q, $translate, $mdDialog, $document, $state, toast, types, utils, tkDialogs, userService,
                                             gatewayModelService) {

    var service = {
        getConfig: getConfig
    }

    return service;

    function getConfig(params) {
        var deferred = $q.defer();
        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;
        var access = types.authority[authority].access;
        var tableConfiguration = createGatewayModelConfig(scope, access, params);
        deferred.resolve(tableConfiguration);
        return deferred.promise;
    }

    function createGatewayModelConfig(scope, access, params, entityTitle) {

        var tableConfiguration = {

            scope: scope,

            entityType: types.entityType.gateway_model,

            tableTitle: getTitle(scope, entityTitle),

            columns: [
                { key: 'createdTime',
                    title: 'entity.createdTime'},
                { key: 'manufacturer',
                    title: 'gateway-model.manufacturer'},
                { key: 'name',
                    title: 'gateway-model.name'},
                { key: 'gatewayFrequency',
                    title: 'gateway-model.gateway-frequency',
                    cellContentFunction: (value) => $translate.instant(types.gatewayFrequency[value].name)
                }
            ],

            loadEntities: () => {return gatewayModelService.getProviderGatewayModels()},
            loadEntity: (entityId) => {return gatewayModelService.getGatewayModel(entityId)},
            saveEntity: (entity) => {return gatewayModelService.saveGatewayModel(entity)},
            deleteEntity: (entityId) => {return gatewayModelService.deleteGatewayModel(entityId)},

            addEnabled: () => {
                return scope == types.scope.provider && access == types.access.admin;
            },
            detailsReadOnly: () => {
                return access == types.access.user;
            },
            deleteEnabled: () => {
                return scope == types.scope.provider && access == types.access.admin;
            },
            entitiesDeleteEnabled: () => {
                return scope == types.scope.provider && access == types.access.admin;
            },
            deleteEntityTitle: (entity) => {
                return $translate.instant('gateway-model.delete-gateway-model-title', {name: entity.name});
            },
            deleteEntityContent: (/*entity*/) => {
                return $translate.instant('gateway-model.delete-gateway-model-text');
            },
            deleteEntitiesTitle: (count) => {
                return $translate.instant('gateway-model.delete-gateway-models-title', {count: count}, 'messageformat');
            },
            deleteEntitiesContent: (/*count*/) => {
                return $translate.instant('gateway-model.delete-gateway-models-text');
            }

        };

        tableConfiguration.actionCellDescriptors = [
        ];

        utils.tableConfigDefaults(tableConfiguration);

        return tableConfiguration;
    }

    function getTitle(scope, entityTitle) {
        var title = $translate.instant('gateway-model.gateway-models');

        if (entityTitle && entityTitle.length) {
            title = entityTitle + ': ' + title;
        }
        return title;
    }

}



// WEBPACK FOOTER //
// ./src/app/gateway-model/gateway-model-table.config.js